module.exports = __webpack_public_path__ + "img/4.2e230637.png";